/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import SearchBox from 'components/New/SearchBox';
import PageTitle from 'components/New/Page/PageTitle';
import classes from './PageHeader.module.scss';

const PageHeader = ({
  className = '',
  title,
  searchPlaceholder,
  onSearch,
  searchVal,
  nonSearch,
}) => {
  return (
    <div className={cn(classes.wrapper, className)}>
      <PageTitle className={classes.title}>{title}</PageTitle>
      {!nonSearch && (
        <SearchBox
          className={classes.searchBox}
          placeholder={searchPlaceholder}
          onSearch={onSearch}
          searchVal={searchVal}
        />
      )}
    </div>
  );
};

export default PageHeader;
